<template>
  <div class="container mx-auto mt-3">
    <Tabs :value="route(route().current())" @update:value="updateUrl">
      <TabList>
        <Tab :value="route('quick-valuation.index')">
          {{ $t('messages.quickValuation.tabs.new') }}
        </Tab>
        <Tab :value="route('quick-valuation.history')">
          {{ $t('messages.quickValuation.tabs.history') }}
        </Tab>
      </TabList>
    </Tabs>
  </div>
</template>

<script setup>
import { router, usePage } from '@inertiajs/vue3'

const page = usePage()

const updateUrl = value => {
  if (value !== page.url) {
    router.visit(value)
  }
}
</script>
